import { render, staticRenderFns } from "./HalfDonutSkill.vue?vue&type=template&id=df745930&"
import script from "./HalfDonutSkill.vue?vue&type=script&lang=js&"
export * from "./HalfDonutSkill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports